/**
 * OrbDocGettingStartedIntroductionARDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocGettingStartedIntroductionARDocScreen
 */

import { useOrbDocGettingStartedIntroductionARDocScreenLogic } from '@/hooks/traits/useOrbDocGettingStartedIntroductionARDocScreenLogic';
import type { OrbDocGettingStartedIntroductionARDocScreenConfig } from '@/hooks/traits/useOrbDocGettingStartedIntroductionARDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocGettingStartedIntroductionARDocView as OrbDocGettingStartedIntroductionARDocViewEntity } from '@app/shared';
import { OrbDocGettingStartedIntroductionARDocBodyView } from '@/components/traits/OrbDocGettingStartedIntroductionARDocBodyView';
import { OrbDocGettingStartedIntroductionARDocFooterView } from '@/components/traits/OrbDocGettingStartedIntroductionARDocFooterView';
import { OrbDocGettingStartedIntroductionARDocHeaderView } from '@/components/traits/OrbDocGettingStartedIntroductionARDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocGettingStartedIntroductionARDocScreenViewProps {
  config?: Partial<OrbDocGettingStartedIntroductionARDocScreenConfig>;
}

export function OrbDocGettingStartedIntroductionARDocScreenView({ config: propsConfig }: OrbDocGettingStartedIntroductionARDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocGettingStartedIntroductionARDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocGettingStartedIntroductionARDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocGettingStartedIntroductionAR" trait="OrbDocGettingStartedIntroductionARDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocGettingStartedIntroductionARDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocGettingStartedIntroductionARDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocGettingStartedIntroductionARDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocGettingStartedIntroductionARDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocGettingStartedIntroductionARDocScreenView;
